"use client";

import { LazyMotion, domAnimation } from "framer-motion";
import type { ReactNode } from "react";

// LazyMotion + domAnimation — framer-motion'ın "full motion" bundle'ı
// (≈58 KB gz) yerine sadece transform/opacity animasyonları için gereken
// mini paketi yükler (≈22 KB gz). `strict` bayrağı `motion.*` namespace
// kullanımını engelleyip zorla `m.*` kullanılmasını ister; böylece
// tree-shake garanti altına alınır.
//
// Tüm framer-motion import'ları `import { m as motion } from "framer-motion"`
// formatını kullanıyor — JSX tarafı değişmedi (<motion.div>, <AnimatePresence>
// aynen kullanılabilir).
export function MotionProvider({ children }: { children: ReactNode }) {
  return (
    <LazyMotion features={domAnimation} strict>
      {children}
    </LazyMotion>
  );
}
